// Configuration for risk detail fields and sections

export interface RiskFieldConfig {
  key: string;
  label: string;
  type?: 'text' | 'select' | 'tags' | 'date' | 'textarea' | 'controlcombobox' | 'assetscombobox';
  options?: any[];
  section: string;
  fullWidth?: boolean;
  readOnly?: boolean;
}

export function generateFieldConfig(menus, users: any[], isCreateMode: boolean = false): RiskFieldConfig[] {
  const fields: RiskFieldConfig[] = [];

  // Only include the Risk ID field if we're not in create mode
  if (!isCreateMode) {
    fields.push({ key: 'riskID', label: 'Risk ID', section: 'Basic Information', type: 'text', readOnly: true });
  }

  let items: RiskFieldConfig[] = [
    // Basic Information
    { key: 'risk', label: 'Risk Description', section: 'Basic Information', type: 'textarea', fullWidth: false },
    { key: 'riskCategory', label: 'Risk Category', section: 'Basic Information', type: 'select', options: menus.riskCategory || [] },
    { key: 'businessUnit', label: 'Business Unit', section: 'Basic Information', type: 'select', options: menus.businessUnit || [] },
    { key: 'riskOwner', label: 'Risk Owner', section: 'Basic Information', type: 'select', options: users.map((u: any) => ({ key: `${u.firstName} ${u.lastName} <${u.email}>`, value: u.id })) },
    { key: 'lastReviewDate', label: 'Last Review Date', section: 'Basic Information', type: 'date' },
    { key: 'nextReviewDate', label: 'Next Review Date', section: 'Basic Information', type: 'date' },

    // Risk Assessment
    { key: 'inherentLike', label: 'Inherent Likelihood', section: 'Risk Assessment', type: 'select', options: menus.inherentLike || [] },
    { key: 'inherentCons', label: 'Inherent Consequences', section: 'Risk Assessment', type: 'select', options: menus.inherentCons || [] },
    { key: 'inherentRisk', label: 'Inherent Risk', section: 'Risk Assessment', type: 'select', options: menus.inherentRisk || [] },
    { key: 'consType', label: 'Consequence Type', section: 'Risk Assessment', type: 'select', options: menus.consType || [] },
    { key: 'controlEffect', label: 'Control Effectiveness', section: 'Risk Assessment', type: 'select', options: menus.controlEffect || [] },
    { key: 'residualRisk', label: 'Residual Risk', section: 'Risk Assessment', type: 'select', options: menus.residualRisk || [] },
    { key: 'targetRisk', label: 'Target Risk', section: 'Risk Assessment', type: 'select', options: menus.targetRisk || [] },
    // { key: 'riskRating', label: 'Risk Rating', section: 'Risk Assessment', type: 'select', options: menus.targetRisk || [] },
    { key: 'treatmentRequired', label: 'Treatment Required', section: 'Risk Assessment', type: 'select', options: menus.treatRequired || [] },
    {
      key: 'response',
      label: 'Response',
      section: 'Risk Assessment',
      type: 'select',
      options: (menus.response || []).some(opt => opt.toLowerCase() === "treat".toLowerCase()) ? menus.response : [...(menus.response || []), "Treat"],
    },
    { key: 'reduction', label: 'Reduction', section: 'Risk Assessment', type: 'select', options: ['Likelihood', 'Consequence'] },

    // Controls & Treatment
    { key: 'selectedControls', label: 'Controls Implemented', section: 'Controls & Treatment', type: 'controlcombobox', fullWidth: true }, //controlsImplemented
    { key: 'assets', label: 'Related Assets', section: 'Controls & Treatment', type: 'assetscombobox', fullWidth: true },
    { key: 'additionalControls', label: 'Additional Controls', section: 'Controls & Treatment', type: 'textarea', fullWidth: true },
    { key: 'treatmentPlan', label: 'Treatment Plan', section: 'Controls & Treatment', type: 'textarea', fullWidth: true },

    // Additional Details
    { key: 'cause', label: 'Cause', section: 'Additional Details', type: 'textarea', fullWidth: true },
    { key: 'impact', label: 'Impact', section: 'Additional Details', type: 'textarea', fullWidth: true },

    // Custom Fields (handled dynamically)
    // { key: 'customField1', label: 'Custom Field 1', section: 'Custom Fields', type: 'text' },
  ];

  return [...fields, ...items] as RiskFieldConfig[];
}
